import type { CmmdProjectUpdateStatus } from "@cmmd-forge/contracts";

import { cn } from "~/lib/utils";

export const PROJECT_UPDATE_STATUS_META: Record<
  CmmdProjectUpdateStatus,
  { readonly label: string; readonly dot: string; readonly text: string }
> = {
  on_track: { label: "On track", dot: "bg-success", text: "text-success-foreground" },
  at_risk: { label: "At risk", dot: "bg-warning", text: "text-warning-foreground" },
  off_track: { label: "Off track", dot: "bg-hue-rose", text: "text-hue-rose-foreground" },
  complete: { label: "Complete", dot: "bg-hue-sky", text: "text-hue-sky-foreground" },
};

const PROJECT_UPDATE_STATUS_OPTIONS: readonly CmmdProjectUpdateStatus[] = [
  "on_track",
  "at_risk",
  "off_track",
  "complete",
];

export interface ProjectUpdateStatusPickerProps {
  readonly value: CmmdProjectUpdateStatus;
  readonly disabled?: boolean;
  readonly onChange: (status: CmmdProjectUpdateStatus) => void;
}

export function ProjectUpdateStatusPicker(props: ProjectUpdateStatusPickerProps) {
  return (
    <div
      className="mb-3 inline-flex flex-wrap gap-0.5 rounded-md bg-background/50 p-0.5"
      aria-label="Project update status"
      role="group"
    >
      {PROJECT_UPDATE_STATUS_OPTIONS.map((option) => {
        const meta = PROJECT_UPDATE_STATUS_META[option];
        const active = props.value === option;
        return (
          <button
            key={option}
            type="button"
            onClick={() => props.onChange(option)}
            disabled={props.disabled === true}
            aria-pressed={active}
            className={cn(
              "inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-xs font-medium transition-colors duration-150 disabled:opacity-40",
              active
                ? cn("bg-background text-foreground shadow-sm", meta.text)
                : "text-muted-foreground hover:text-foreground",
            )}
          >
            <span className={cn("size-1.5 rounded-full", meta.dot)} aria-hidden />
            {meta.label}
          </button>
        );
      })}
    </div>
  );
}
